import { render, staticRenderFns } from "./InstitutionalHolding.vue?vue&type=template&id=40fb0ea9&scoped=true"
import script from "./InstitutionalHolding.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionalHolding.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InstitutionalHolding.vue?vue&type=style&index=0&id=40fb0ea9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb0ea9",
  null
  
)

export default component.exports